import { Link } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import PageIntro from '@/components/feature/PageIntro';
import Container from '@/components/base/Container';
import Eyebrow from '@/components/base/Eyebrow';
import FinalCta from '@/components/feature/FinalCta';
import ImageReveal from '@/components/base/ImageReveal';

const coverageSteps = [
  { title: 'Send a request', text: 'Use the booking form and include your full service address.' },
  { title: 'We check your address', text: 'We review the location against our current service area.' },
  { title: 'We confirm with you', text: 'We contact you to confirm coverage and arrange a time, or let you know if we cannot help.' },
];

export default function ServiceAreasPage() {
  return (
    <PageShell>
      <PageIntro eyebrow="Service Areas" title="Service Coverage">
        MENDWELL provides local, in-home appliance repair. Our detailed coverage list is being finalized.
      </PageIntro>
      <section className="bg-background-50 pb-20 md:pb-32">
        <Container>
          <div className="relative">
          <ImageReveal className="relative overflow-hidden rounded-xl bg-primary-100">
            <img
              src="https://public.readdy.ai/ai/img_res/sandbox/f2895d2f16dd8702941ce32547f07592/1802b3df-061e-4996-b201-639cd7eafb1d_mw-areas.webp"
              width={1920}
              height={900}
              alt="Quiet residential neighborhood in soft morning light"
              title="MENDWELL local service coverage"
              className="h-[260px] sm:h-[360px] md:h-[560px] w-full object-cover object-top"
            />
            <div className="absolute inset-0 hidden bg-gradient-to-t from-black/40 to-transparent md:block" />
          </ImageReveal>
            <div className="mt-4 md:absolute md:inset-x-0 md:bottom-0 md:mt-0 md:p-12">
              <div className="max-w-lg min-w-0 rounded-xl border border-background-200 bg-background-50 p-6 md:border-0 md:p-8">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-map-pin-line text-lg" />
                </div>
                <h2 className="mt-5 text-xl md:text-2xl font-medium tracking-tight text-foreground-950">Not sure if we cover your address?</h2>
                <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-foreground-600">
                  Include your full service address in a booking request. We&apos;ll confirm whether it falls within our area before scheduling a visit.
                </p>
                <Link to="/book" className="mt-6 inline-flex h-11 items-center whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm text-white hover:bg-primary-600 transition-colors">
                  Send a Request
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section className="bg-background-100 py-16 md:py-24">
        <Container>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-16">
            <Eyebrow label="How Coverage Works" />
            <h2 className="text-[30px] md:text-[44px] font-medium leading-[1.05] tracking-[-0.025em] text-foreground-950">Three steps to confirm your address.</h2>
          </div>
          <div className="mt-12">
            {coverageSteps.map((s, i) => (
              <div key={s.title} className="grid grid-cols-1 gap-3 border-t border-background-200 py-8 lg:grid-cols-2 lg:gap-16 last:border-b">
                <span className="text-xs text-foreground-600">{`0${i + 1}.`}</span>
                <div>
                  <h3 className="text-lg font-medium text-foreground-950">{s.title}</h3>
                  <p className="mt-2 max-w-md text-[15px] leading-relaxed text-foreground-600">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
      <FinalCta />
    </PageShell>
  );
}